import type { ITeacherHome } from '@/Module/HomePage/Model/DataModel';

export const SAMPLE_TEACHERS: ITeacherHome[] = [
  //  {
  //    id: 1,
  //    name: 'حمیدرضا جوشقانی',
  //    grade: 'فیزیک',
  //    img: 'tizhoshan-joshaghani',
  //    color: 'orange',
  //    description: `مدرس علامه حلی، علامه طباطبایی
  // مولف کتاب ۱۰۰ نکته و ۲۰ آزمون در نشر استاندارد`,
  //    url: 'https://ino.school/teacher/%d8%ad%d9%85%db%8c%d8%af%d8%b1%d8%b6%d8%a7-%d8%ac%d9%88%d8%b4%d9%82%d8%a7%d9%86%db%8c/',
  //  },
  {
    id: 1,
    name: 'علیرضا شیخ عطار',
    grade: 'ریاضی‌',
    img: 'tizhoshan-sheykhatar',
    color: 'orange',
    description: `مدرس مدرسه علامه حلی
 مولف کتاب  ریاضی نهم انتشارات علامه حلی`,
    url: 'https://ino.school/teacher/%d8%b9%d9%84%db%8c%d8%b1%d8%b6%d8%a7-%d8%b4%db%8c%d8%ae-%d8%b9%d8%b7%d8%a7%d8%b1/',
  },
  {
    id: 2,
    name: 'حسن نشتایی',
    grade: 'زیست‌شناسی',
    img: 'konkor-nashtaei',
    color: 'primary',
    description: `مدرس علامه حلی و فرزانگان
مولف کتاب تست زیست‌شناسی انتشارات خیلی سبز`,
    url: 'https://ino.school/teacher/%D8%AD%D8%B3%D9%86-%D9%86%D8%B4%D8%AA%D8%A7%DB%8C%DB%8C/',
  },
  //   {
  //     id: 3,
  //     name: 'محمد حسین ملکوتی',
  //     grade: 'شیمی',
  //     img: 'tizhoshan-malakoti',
  //     color: 'green',
  //     description: `مدرس علامه حلی و مصباح علم
  // مولف کتاب  شیمی پایه دوازدهم +۶۰`,
  //     url: 'https://ino.school/teacher/%d9%85%d8%ad%d9%85%d8%af-%d8%ad%d8%b3%db%8c%d9%86-%d9%85%d9%84%da%a9%d9%88%d8%aa%db%8c/',
  //   },
  {
    id: 3,
    name: 'حسین شفیع زاده',
    grade: 'ریاضی',
    img: 'konkor-shafiezade',
    color: 'green',
    description: `مدرس انرژی اتمی،  فرزانگان و سلام
مولف کتاب‌ حسابان نردبام و ریاضیات پایه انتشارات خیلی سبز`,
    url: 'https://ino.school/teacher/%D8%AD%D8%B3%DB%8C%D9%86-%D8%B4%D9%81%DB%8C%D8%B9-%D8%B2%D8%A7%D8%AF%D9%87/',
  },
  {
    id: 4,
    name: 'محمد رزمی',
    grade: 'فارسی',
    img: 'tizhoshan-razmi',
    color: 'pink',
    description: `مدرس انرژی اتمی و علامه حلی
 مولف ماجراهای من و درسام فارسی دهم و یازدهم`,
    url: 'https://ino.school/teacher/%D9%85%D8%AD%D9%85%D8%AF-%D8%B1%D8%B2%D9%85%DB%8C/',
  },
];
